/* NC storefront layer: no dependencies. Re-initialises in the Theme Editor. */
(() => {
  'use strict';
  if (window.__ncLoaded) return; window.__ncLoaded = true;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const once = (el, key) => (el.dataset[key] ? false : (el.dataset[key] = '1'));

  function rotator(root) {
    if (!once(root, 'ncRot')) return;
    const msgs = [...root.querySelectorAll('.nc-announce__msg')];
    if (msgs.length < 2) return;
    let i = 0; let timer;
    const interval = Number(root.dataset.interval) || 5000;
    const show = (n) => {
      msgs[i].classList.remove('is-active'); msgs[i].setAttribute('aria-hidden', 'true');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active'); msgs[i].removeAttribute('aria-hidden');
    };
    const start = () => { if (!reduceMotion) timer = setInterval(() => show(i + 1), interval); };
    const stop = () => clearInterval(timer);
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    start();
  }

  const scrollToIndex = (track, index) => {
    const slide = track.children[index];
    if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  function gallery(root) {
    if (!once(root, 'ncGal')) return;
    const track = root.querySelector('[data-nc-gallery-track]');
    const thumbs = [...root.querySelectorAll('[data-nc-thumb]')];
    if (!track) return;
    thumbs.forEach((t) => t.addEventListener('click', () => scrollToIndex(track, Number(t.dataset.ncThumb))));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((t, n) => {
          t.classList.toggle('is-active', n === idx);
          if (n === idx) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      });
    }, { passive: true });
    root.ncGoToMedia = (mediaId) => {
      const idx = [...track.children].findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (idx > -1) scrollToIndex(track, idx);
    };
  }

  function product(root) {
    if (!once(root, 'ncPdp')) return;
    const form = root.querySelector('[data-nc-form]');
    const dataEl = root.querySelector('[data-nc-variants]');
    const galleryEl = root.querySelector('[data-nc-gallery]');
    const sticky = root.querySelector('[data-nc-sticky]');

    root.querySelectorAll('[data-nc-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.ncQty));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (form && dataEl) {
      let variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      const idInput = form.querySelector('[data-nc-variant-id]');
      const addBtn = form.querySelector('[data-nc-add]');
      const addLabel = form.querySelector('[data-nc-add-label]');
      const addText = addLabel ? addLabel.textContent.trim() : 'Add to cart';
      const stickyBtn = root.querySelector('[data-nc-sticky-add]');
      const priceEls = root.querySelectorAll('[data-nc-price], [data-nc-price-sticky]');
      const compareEl = root.querySelector('[data-nc-compare]');
      const badgeEl = root.querySelector('[data-nc-badge]');
      const badgeVal = root.querySelector('[data-nc-badge-value]');
      const radios = [...form.querySelectorAll('[data-nc-option]')];
      const selected = () => { const o = []; radios.forEach((r) => { if (r.checked) o[Number(r.dataset.ncOption)] = r.value; }); return o; };
      const markAvailability = (opts) => {
        radios.forEach((r) => {
          const test = opts.slice(); test[Number(r.dataset.ncOption)] = r.value;
          const m = variants.find((v) => v.options.every((o, n) => o === test[n]));
          r.classList.toggle('is-unavailable', !m || !m.available);
        });
      };
      const update = () => {
        const opts = selected();
        const v = variants.find((x) => x.options.every((o, n) => o === opts[n]));
        opts.forEach((val, n) => { const l = form.querySelector(`[data-nc-option-label="${n}"]`); if (l) l.textContent = val; });
        markAvailability(opts);
        const buttons = [addBtn, stickyBtn].filter(Boolean);
        if (!v) { buttons.forEach((b) => { b.disabled = true; }); if (addLabel) addLabel.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        buttons.forEach((b) => { b.disabled = !v.available; });
        if (addLabel) addLabel.textContent = v.available ? addText : 'Sold out';
        priceEls.forEach((el) => { el.textContent = v.price; });
        if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
        if (badgeEl) { badgeEl.hidden = !v.save; if (badgeVal) badgeVal.textContent = v.save; }
        if (v.media && galleryEl && galleryEl.ncGoToMedia) galleryEl.ncGoToMedia(v.media);
        if (/\/products\//.test(location.pathname)) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      };
      radios.forEach((r) => r.addEventListener('change', update));
      if (radios.length) markAvailability(selected());
      form.addEventListener('submit', () => { if (addBtn) addBtn.setAttribute('aria-busy', 'true'); });
    }

    if (sticky && form) {
      const mainBtn = form.querySelector('[data-nc-add]');
      const mode = sticky.dataset.mode;
      if (sticky.classList.contains('nc-sticky-atc--desktop')) document.body.classList.add('nc-sticky-desktop');
      let buttonVisible = true;
      const setVisible = (on) => {
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
        document.body.classList.toggle('nc-sticky-on', on);
      };
      const evaluate = () => {
        const rect = mainBtn.getBoundingClientRect();
        const nearFooter = window.innerHeight + window.scrollY >= document.body.scrollHeight - 200;
        const on = mode === 'after_button'
          ? rect.bottom < 0 && !nearFooter
          : window.scrollY > window.innerHeight * 0.8 && !buttonVisible && !nearFooter;
        setVisible(on);
      };
      if ('IntersectionObserver' in window) new IntersectionObserver((e) => { buttonVisible = e[0].isIntersecting; evaluate(); }).observe(mainBtn);
      let ticking = false;
      window.addEventListener('scroll', () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { evaluate(); ticking = false; }); }, { passive: true });
    }
  }

  function carousel(root) {
    if (!once(root, 'ncCar')) return;
    const track = root.querySelector('[data-nc-track]');
    const prev = root.querySelector('[data-nc-prev]');
    const next = root.querySelector('[data-nc-next]');
    if (!track || !prev || !next) return;
    const step = () => (track.children[0] ? track.children[0].getBoundingClientRect().width + 16 : track.clientWidth);
    const sync = () => { prev.disabled = track.scrollLeft <= 4; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function beforeAfter(root) {
    if (!once(root, 'ncBa')) return;
    const range = root.querySelector('[data-nc-ba-range]');
    if (!range) return;
    const set = () => root.style.setProperty('--pos', `${range.value}%`);
    range.addEventListener('input', set); set();
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-nc-rotator]').forEach(rotator);
    scope.querySelectorAll('[data-nc-gallery]').forEach(gallery);
    scope.querySelectorAll('[data-nc-product]').forEach(product);
    scope.querySelectorAll('[data-nc-carousel]').forEach(carousel);
    scope.querySelectorAll('[data-nc-ba]').forEach(beforeAfter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('nc-sticky-on'));
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.nc-review, .nc-gallery__slide');
    const track = slide && slide.parentElement;
    if (track) scrollToIndex(track, [...track.children].indexOf(slide));
  });
})();
